import { useQuery } from "@tanstack/react-query";
import { getStudent } from "../../api/apiStudents";
import i18next from "i18next";
export function useGetStudent(id) {
    const { isLoading, data: student, error } = useQuery({ queryKey: ["students", id, i18next.language], queryFn: () => getStudent(id), enabled: !!id, retry: false });
    return { isLoading, error, student };
}
